import { render, staticRenderFns } from "./domicile.vue?vue&type=template&id=a8bebe6c"
import script from "./domicile.vue?vue&type=script&lang=js"
export * from "./domicile.vue?vue&type=script&lang=js"
import style0 from "./domicile.vue?vue&type=style&index=0&id=a8bebe6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports